export const productsReducer = (state = {loading:true,result:null,products:null,product:null} , action) => {
    switch (action.type) {
        case 'PRODUCT_SEND_SUCCESS':
            return {
                ...state,
                loading:false,
                result: action.payload
            }
        case 'PRODUCTS_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                products: action.payload
            }
        case 'PRODUCT_GET_DETAIL_SUCCESS':
            return {
                ...state,
                loading:false,
                product: action.payload
            }
        case 'PRODUCT_ACTIVE_SUCCESS':
            return {
                ...state,
                loading:false,
                products: 
                    state.products.map((product) => {
                        if(product._id === action.payload._id){
                            return action.payload
                        }else{
                            return product
                        }
                    })
            }
        case 'PRODUCT_DELETE_SUCCESS':
            return {...state,
                loading:false,
                result: action.payload.message,
                products: state.products.filter(product => product._id !== action.payload.idProduct)
            }
        case 'PRODUCT_DELETE_NOT_SUCCESS':
            return {...state,
                loading: false,
                result: action.payload
            }
        case 'PRODUCT_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'PRODUCT_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'PRODUCT_ERROR':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

